import React, { useEffect, useState } from "react";
import { FiSave } from "react-icons/fi";
import PageHeaderSetting from "../shared/pageHeader/PageHeaderSetting";
import PerfectScrollbar from "react-perfect-scrollbar";
import Footer from "../shared/Footer";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const MASK_VALUE = "******"; // Mask değeri
// Hangi alanların gizli olduğunu belirleyelim:
const secretFields = ["cdn_key", "cdn_secret", "cdn_bucket"];

const SettingsCdnForm = () => {
  const [apiSettings, setApiSettings] = useState({
    mailjet_title: "",
    mailjet_secret: "",
    mailjet_api: "",
    cdn_key: "",
    cdn_secret: "",
    cdn_endpoint: "",
    cdn_bucket: "",
    cdn_region: "",
    cdn_path: "",
    cdn_folder: "", 
    paytr_merchant_id: "",
    paytr_merchant_key: "",
    paytr_merchant_salt: "",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);
  const getText = (key, defaultValue) =>
    translations[key] || defaultValue || key;

  useEffect(() => {
    fetchApiData();
  }, []);

  // API'den verileri çekip state'e yazıyoruz.
  const fetchApiData = async () => {
    try {
      const resp = await axios.get(`${BASE_URL}/api/cdn-config`);
      console.log("Gelen API Data:", resp.data);
      // Eğer API'den çekilen gizli alanlarda değer varsa, onu maskeli olarak set edelim.
      const data = { ...resp.data };
      secretFields.forEach((field) => {
        if (data[field] && data[field] !== "") {
          data[field] = MASK_VALUE;
        }
      });
      setApiSettings((prevState) => ({
        ...prevState,
        ...data,
      }));
    } catch (err) {
      console.error("API verisi çekme hatası:", err);
      toast.error("API ayarları alınamadı!");
    }
  };

  // Input değişikliklerini handle etme
  const handleChange = (e) => {
    const { name, value } = e.target;
    setApiSettings((prev) => ({
      ...prev,
      // Eğer alan gizli ise ve değer MASK_VALUE ise eski değeri koru.
      [name]:
        secretFields.includes(name) && value === MASK_VALUE
          ? prev[name]
          : value,
    }));
  };

  // Gizli alanlara tıklanınca maskeyi temizle
  const handleSecretFocus = (e) => {
    if (e.target.value === MASK_VALUE) {
      e.target.value = "";
      setApiSettings((prev) => ({
        ...prev,
        [e.target.name]: "",
      }));
    }
  };

  // Kaydet butonuna basınca API'yi güncelle
  const handleSave = async () => {
    try {
      // Güncellenecek veriyi hazırlarken, gizli alanlarda kullanıcı değişiklik yapmamışsa
      // ilgili alanı gönderimden çıkarıyoruz.
      const dataToSave = { ...apiSettings };
      secretFields.forEach((field) => {
        if (dataToSave[field] === MASK_VALUE) {
          delete dataToSave[field];
        }
      });

      await axios.put(`${BASE_URL}/api/cdn-config`, dataToSave);
      toast.success(getText("SUCCESS_API_UPDATED"));
      fetchApiData(); // Güncellenmiş verileri tekrar çek
    } catch (error) {
      console.error("API Bilgileri kaydedilemedi:", error);
      toast.error("Kayıt hatası oluştu!");
    }
  };

  // Gözükmesini istediğimiz alanları tanımlayalım
  const fields = [
    "cdn_key",
    "cdn_secret",
    "cdn_endpoint",
    "cdn_bucket",
    "cdn_region",
    "cdn_path",
    "cdn_folder",
  ];

  return (
    <div className="content-area setting-form">
      <ToastContainer />
      <PerfectScrollbar>
        <PageHeaderSetting />
        <div className="content-area-body">
          <div className="card mb-0">
            <div className="card-body">
              {/* S3 CDN Ayarları için inputlar */}
              {fields.map((field) => {
                const isSecret = secretFields.includes(field);
                return (
                  <div className="mb-3" key={field}>
                    <label className="form-label fw-bold">
                      {getText(`LABEL_${field.toUpperCase()}`, field.replace(/_/g, " ").toUpperCase())}
                    </label>
                    <input
                      type={isSecret ? "password" : "text"}
                      className="form-control"
                      name={field}
                      value={apiSettings[field] || ""}
                      onChange={handleChange}
                      onFocus={isSecret ? handleSecretFocus : undefined}
                      placeholder={isSecret ? MASK_VALUE : ""}
                      autoComplete="off"
                    />
                  </div>
                );
              })}
              {/* KAYDET BUTONU */}
              <div className="d-flex justify-content-center">
                <button className="btn btn-primary" onClick={handleSave}>
                  <FiSave className="me-2" /> {getText("SAVE_BTN")}
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </PerfectScrollbar>
    </div>
  );
};

export default SettingsCdnForm;
